import { DataSource, Layout, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutObjectionQuickInfo extends Layout {
    sourceObjection: DataSource;
    textboxDescr: Textbox;
    textboxId: Textbox;
}
